import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, IconButton, SvgIcon, TextField } from '@/core/ui';
import { Grow, Popper } from '@mui/material';
import { useEffect, useRef } from 'react';
import magnifyingGlassIcon from '@/core/svg/fa/light/magnifying-glass.svg';
import xMarkIcon from '@/core/svg/fa/xmark.svg';
import { useOverrideWindowFindShortcut } from '@/warehouse/hooks';
import { useCtrlFSearchPopoverStore } from './business';
import { PaperStyled } from './CtrlFSearchPopover.styled';
const CtrlFSearchPopover = () => {
    const { open, searchTerm, setSearchTerm, openPopoverFilter, closePopover } = useCtrlFSearchPopoverStore((state) => state);
    useOverrideWindowFindShortcut(openPopoverFilter);
    const anchorElementRef = useRef(null);
    useEffect(() => {
        return () => {
            closePopover();
        };
    }, [closePopover]);
    const handlePopperKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
        }
        if (event.key === 'Escape') {
            event.preventDefault();
            closePopover();
        }
    };
    const handleChange = (event) => {
        event.preventDefault();
        setSearchTerm(event.target.value);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { ref: anchorElementRef }), _jsx(Popper, { open: open, anchorEl: anchorElementRef.current, placement: "bottom", modifiers: [
                    {
                        name: 'offset',
                        enabled: true,
                        options: {
                            offset: [0, -48],
                        },
                    },
                ], transition: true, onKeyDown: handlePopperKeyDown, children: ({ TransitionProps }) => (_jsx(Grow, { ...TransitionProps, timeout: 100, children: _jsxs(PaperStyled, { children: [_jsx(TextField, { autoFocus: true, value: searchTerm, startAdornment: _jsx(SvgIcon, { icon: magnifyingGlassIcon, size: "2xs", disabled: true }), onChange: handleChange }), _jsx(IconButton, { onClick: closePopover, children: _jsx(SvgIcon, { icon: xMarkIcon, size: "md" }) })] }) })) })] }));
};
export { CtrlFSearchPopover };
